import useAct from 'DesktopCaller/useAct'

export default function LinesClosed() {
  const act = useAct()

  return <div className={`box`}>
    <div className='part'>
      <div className='type'><h2 className='no-margin-top'>{ i18n.t('user.campaigns.phone.lines_are_closed') }</h2></div>
      <div className='content'>
        <p>{ i18n.t('user.campaigns.phone.lines_are_closed_desc') }</p>
        <div className='buttons'>
          <button className="button red primary small" onClick={() => act.desktopCaller.disconnect()}>
            <SvgIconsCallerHangUp />{' '}
            <span>{i18n.t('user.campaigns.phone.disconnect')}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
}